import {useEffect, useState, useMemo, useCallback, useRef} from 'react';
import {POPUP_DISPLAY} from "../../core/models/popup/consts";

export const useDynamicPopup = ({
  dynamicPopupModel,
  sportTypeId,
  userCountryId,
  popupsDisplayManager,
  navigationManager
}) => {
  const [shouldRenderPopup, setShouldRenderPopup] = useState(false);

  const validPopupModel = useMemo(() => {
    if (!dynamicPopupModel) return null;
    
    const popupModels = Array.isArray(dynamicPopupModel) ? dynamicPopupModel : [dynamicPopupModel];
    
    if (sportTypeId <= 0) return null;

    return popupModels.find(model => {
      if (!model) return false;
      
      const isValidByCountry = model.isValidByUserCountryId(userCountryId);
      const isValidBySport = model.isValidBySportTypeId(sportTypeId);
      const isValidByURL = model.isValidByURL(window.location.pathname || window.location.path);
      
      return isValidByCountry && isValidBySport && isValidByURL;
    }) || null;
  }, [dynamicPopupModel, sportTypeId, userCountryId]);

  const validPopupModelRef = useRef(validPopupModel);
  useEffect(() => {
    validPopupModelRef.current = validPopupModel;
  }, [validPopupModel]);

  const displayPopup = useCallback(() => {
    const isVisible = !!validPopupModelRef.current;
    setShouldRenderPopup(isVisible);
    popupsDisplayManager.setPopupDisplayStatus(POPUP_DISPLAY.AUTO_DISPLAY_POPUPS.dynamicPopup, isVisible);
  }, [popupsDisplayManager]);

  useEffect(() => {
    if (dynamicPopupModel) {
      popupsDisplayManager.registerToChange(
        POPUP_DISPLAY.AUTO_DISPLAY_POPUPS.dynamicPopup,
        (params) => setTimeout(() => displayPopup(), params.delay * 1000)
      );
    }
  }, [dynamicPopupModel, popupsDisplayManager, displayPopup]);

  const handleClose = () => {
    setShouldRenderPopup(false);
  };

  const handleButtonClick = () => {
    if (validPopupModel?.url) {
      navigationManager.gotoUrl(validPopupModel.url, false, validPopupModel.isExternal);
    }
    setShouldRenderPopup(false);
  };

  return {
    shouldRenderPopup,
    validPopupModel,
    handleClose,
    handleButtonClick
  };
};

